import {Component, Input, OnInit} from '@angular/core';
import {FlujoVentaPaso} from '../../../_models/flujo-venta-paso';
import {TabViewCustom} from '../../../_models/tab-view-custom';
import {SelectItem} from 'primeng/api';

@Component({
  selector: 'app-flujo-venta-contrato',
  templateUrl: './flujo-venta-contrato.component.html',
})
export class FlujoVentaContratoComponent implements OnInit {
  @Input() tabView: TabViewCustom;
  @Input() listaSecuencias: SelectItem[] = [];
  @Input() listaVinculaciones: SelectItem[] = [];
  @Input() listaTiposPersonas: SelectItem[] = [];
  @Input() lisPasos: FlujoVentaPaso[] = [];
  @Input() titulo: string;

  tabSeleccionado = 'DATGEN';

  constructor() {
  }

  ngOnInit() {
  }

  /**
   * Actualiza la pestaña activa del acordeón según el índice abierto
   * @param evento índice de la pestaña abierta (0: datos generales, 1: restricciones por vinculación)
   */
  abrirAcordeon(evento: number) {
    switch (evento) {
      case 0: {
        this.tabSeleccionado = 'DATGEN';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'RESPERXVIN';
        break;
      }
    }
  }
}
